import FormPersianDateField from "./fields/Form/PersianDateField.vue"
import DetailPersianDateField from "./fields/Detail/PersianDateField.vue"
import IndexPersianDateField from "./fields/Index/PersianDateField.vue"
import FormPersianDateTimeField from "./fields/Form/PersianDateTimeField.vue"
import DetailPersianDateTimeField from "./fields/Detail/PersianDateTimeField.vue"
import IndexPersianDateTimeField from "./fields/Index/PersianDateTimeField.vue"
import FormPersianTimeField from "./fields/Form/PersianTimeField.vue"
import DetailPersianTimeField from "./fields/Detail/PersianTimeField.vue"
import IndexPersianTimeField from "./fields/Index/PersianTimeField.vue"
import FilterPersianDateField from "./fields/Filter/PersianDateField.vue"
import FilterPersianDateTimeField from "./fields/Filter/PersianDateTimeField.vue"

const persianDateFieldSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('form-persian-date-field', FormPersianDateField)
    app.component('detail-persian-date-field', DetailPersianDateField)
    app.component('index-persian-date-field', IndexPersianDateField)
    app.component('form-persian-date-time-field', FormPersianDateTimeField)
    app.component('detail-persian-date-time-field', DetailPersianDateTimeField)
    app.component('index-persian-date-time-field', IndexPersianDateTimeField)
    app.component('form-persian-time-field', FormPersianTimeField)
    app.component('detail-persian-time-field', DetailPersianTimeField)
    app.component('index-persian-time-field', IndexPersianTimeField)

    /**
     * Register Filters
     */
    app.component('filter-persian-date-field', FilterPersianDateField)
    app.component('filter-persian-date-time-field', FilterPersianDateTimeField)

}

export { persianDateFieldSetup }